// One font preview tile. Renders the typed text in the font's actual face +
// tracking. Falls back to the font's `sample` string while the customer
// hasn't typed anything.

import type { Font } from "../types";

export function FontTile({
  font,
  text,
  selected,
  onClick,
}: {
  font: Font;
  text: string;
  selected: boolean;
  onClick: () => void;
}) {
  // Phase B1: when the customer hasn't typed yet, preview each font with a
  // short brand placeholder rather than the font's own sample string.
  const raw = text.trim() ? text : "RK";
  // Phase 32b: faces with no lowercase glyphs (College, Stencil Block)
  // should show the preview in caps even if the customer typed in mixed
  // case, so the picker shows what will actually stitch.
  const display = font.forceUppercase ? raw.toUpperCase() : raw;
  return (
    <button
      type="button"
      className={`rk-pc-font-tile${selected ? " is-selected" : ""}`}
      onClick={onClick}
    >
      <span
        className="rk-pc-font-tile__preview"
        style={{ fontFamily: `'${font.family}', system-ui, sans-serif`, letterSpacing: font.tracking || 0 }}
      >
        {display.slice(0, 16)}
      </span>
      <span className="rk-pc-font-tile__name">{font.name}</span>
    </button>
  );
}
